import { useDispatch, useSelector } from 'react-redux';
import { constant } from '@medflex/commons';
import useUserProfile from './useUserProfile';

const DEFAULT_GREETING_MESSAGE = constant.greetingMessage.defaultText;

const useGreetingMessage = () => {
  const { userProfile } = useUserProfile();
  const greetingMessage = userProfile.attributes.greetingMessage || DEFAULT_GREETING_MESSAGE;

  const isSaving = useSelector(state => state.loading.effects.superuser.saveGreetingMessage);

  const dispatch = useDispatch();
  const { saveGreetingMessage } = dispatch.superuser;

  return {
    greetingMessage,
    isSaving,
    saveGreetingMessage,
  };
};

export default useGreetingMessage;
